module.exports = __webpack_public_path__ + "img/sprite.baaf909f.svg";